<template>
  <div class="forgot-password">
    <div>
      <img
        height="36"
        alt="Card Ladder"
        src="@cardladder/shared/images/cardladder-pro-logo.svg"
      />
    </div>

    <div class="form-container">
      <h2>Reset Password</h2>

      <form @submit.prevent="submit">
        <p>Enter your email address below to receive an email to reset your password.</p>
        <p>If you login with Apple or Google this will NOT send you an email.</p>

        <text-input
          id="email"
          v-model.trim="email"
          type="email"
          label="Email"
          required
        />

        <btn
          loading-text="Submitting"
          type="submit"
          block
          :loading="submitting"
        >
          Submit
        </btn>

        <div class="links">
          <a class="link" @click="$router.push({ path: '/login', query: $route.query })">Back to login</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/compat/app';

export default {
  data() {
    return {
      email: '',
      submitting: false,
    };
  },

  methods: {
    async submit() {
      this.submitting = true;

      try {
        // eslint-disable-next-line no-undef
        const token = await grecaptcha.enterprise.execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, { action: 'forgot_password' });
        await firebase.functions().httpsCallable('httpVerifyRecaptcha')({ token, action: 'forgot_password' });

        await firebase.auth().sendPasswordResetEmail(this.email);
      } catch (e) {
        // swallow
      }

      this.$router.push({ path: '/login', query: { ...this.$route.query, email: this.email } });
      this.$toasted.success('An email has been sent to you with a link to reset your password.');

      this.submitting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  padding: $gp;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
}

form {
  width: 360px;
  max-width: 360px;

  @media($medium-down) {
    width: 100%;
  }
}

.links {
  margin-top: $gp;
  font-size: 12px;
}
</style>
